module.exports = __webpack_public_path__ + "static/fonts/iconfont.e9d454e.woff";